import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { SignInErrorPage } from '@/app/Auth/pages/SignInErrorPage';
import { PlainPendingComponent } from '@/app/routerDefaults';
import type { PageStaticData } from '@/shared/routing';
import { browserLanguageLoaded } from '@/shared/utils/internationalisation';

// Where Auth0 sends the browser back after sign-in (`redirect_uri` in `@luminovo/auth`).
// `onRedirectCallback` navigates first, so these redirects land only for a bare or reloaded `/callback`.
export const Route = createFileRoute('/callback')({
    // Rendered bare: the session is still being made here.
    staticData: { access: 'public', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ error: 'optional' }),
    beforeLoad: async ({ context, search }) => {
        // Auth0 refused the sign-in: the SDK never calls `onRedirectCallback`, and the page says why.
        if (search.error !== undefined) {
            return;
        }
        if (await context.auth.isSignedIn()) {
            throw redirect({ to: '/' });
        }
        throw redirect({ to: '/auth/enter-email' });
    },
    // Runs only when `beforeLoad` didn't redirect, so the page renders.
    loader: () => browserLanguageLoaded(),
    component: RouteComponent,
    pendingComponent: PlainPendingComponent,
    // A spinner at once while `beforeLoad` waits for the session, as in `_authenticated`.
    pendingMs: 0,
});

function RouteComponent(): JSX.Element {
    return <SignInErrorPage />;
}
